<script lang="ts">
	import DocIMG from "../../assets/create_store/doc.png";
	import DropIMG from "../../assets/create_store/drop.png";
	import { FormInputComposite, FormSlotComposite } from "@hitit/new_ui/src";
	import { t } from "../../stores";
	import DragAndDrop from "../DragAndDrop.svelte";
	import {
		formatKoreanRegistrationNumberHandler,
		addKoreanRegisterSpacer,
	} from "@hitit/hub/src/v7/utils";
	export let errorMessage = "";
	export let registrationNumb = "";
	export let registrationFile: File | null = null;
	let fileURL = "";

	function setFile(e: any) {
		registrationFile = e.detail as File;

		if (fileURL) {
			URL.revokeObjectURL(fileURL);
		}

		fileURL = URL.createObjectURL(registrationFile);
	}
	function idHanlder(_: HTMLElement, replacedValue: string) {
		registrationNumb = replacedValue;
		errorMessage = "";
	}

</script>

<div class="registration">
	<div class="registration-frame">
		<FormInputComposite
			error={errorMessage !== ''}
			errorMessage={errorMessage}
			length={12}
			outerClassname={'createstore-composite'}
			labelFor={'registration-numb'}
			on:input={(e) => formatKoreanRegistrationNumberHandler(e, idHanlder)}
			value={addKoreanRegisterSpacer(registrationNumb)}
			clearButtonCallback={() => (registrationNumb = '')}
			placeholder={'000-00-00000'}
			inputName={$t('hub.store.ko_registration.id')} />
		<FormSlotComposite
			outerClassname={'createstore-composite'}
			inputName={$t('hub.store.ko_registration.image')}>
			<div class="file-outer">
				<DragAndDrop let:enter on:file-update={setFile}>
					<div
						class="file-inner"
						class:enter
						class:image-view={registrationFile !== null}>
						{#if registrationFile}
							<img id="registration-img" src={fileURL} alt="registration" />
							<span class="white">{registrationFile.name}</span>
						{:else}
							<div class="none-image-description">
								<img src={DocIMG} alt="doc" />
								<span>{$t('hub.store.ko_registration.Click')}</span>
							</div>
							<div class="none-image-description for-desk">
								<span class="or">{$t('hub.store.ko_registration.or')}</span>
							</div>
							<div class="none-image-description for-desk">
								<img src={DropIMG} alt="doc" />
								<span>{$t('hub.store.ko_registration.Drop')}</span>
							</div>
						{/if}
					</div>
				</DragAndDrop>
			</div>
		</FormSlotComposite>
	</div>
	<p class="description">
		{$t('hub.store.ko_registration.can_register_later')}
	</p>
	<empty />
	<slot />
</div>

<style lang="scss">
	@import "../../variables.scss";

	.registration {
		.registration-frame {
			display: flex;
			flex-direction: column;
			gap: 20.5px;

			.file-outer {
				box-sizing: border-box;
				width: 100%;
				height: 180px;

				.file-inner {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 100%;
					height: 100%;
					border: 1px solid;
					border-color: #b4b7bb;
					border-radius: 5px;
					transition: border-color 0.5s;
					&.image-view {
						border-color: transparent;
						justify-content: start;
						align-items: baseline;
						gap: 10px;
					}

					&:hover,
					&.enter {
						cursor: pointer;
						border: 1px solid;
						border-color: var(--signature-blue);
					}
					#registration {
						width: 146px;
						height: 100%;
						object-fit: contain;
					}

					span.white {
						color: white;
						white-space: pre;
						text-overflow: ellipsis;
						overflow: hidden;
					}

					.none-image-description {
						display: flex;
						flex-direction: column;
						gap: 10px;
						justify-content: center;
						align-items: center;

						&.for-desk {
							display: none;
						}

						img {
							width: 20px;
							height: 20px;
						}

						span {
							color: white;
							font-weight: 500;
							font-size: 1.25rem;

							&.or {
								font-size: 1rem;
								font-weight: 300;
								margin-top: 30px;
								color: var(--default-disabled-btn-1);
							}
						}
					}
					#registration-img {
						width: 194px;
						height: 100%;
						object-fit: contain;
					}
				}
			}
		}
		.description {
			margin-top: 10px;
			color: var(--lightGrey);
		}

		empty {
			display: block;
			height: 50px;
		}
	}
	@include DesktopSize {
		.registration {
			.registration-frame {
				.file-outer {
					.file-inner {
						display: flex;
						position: relative;

						.none-image-description {
							position: absolute;

							&:nth-child(1) {
								left: 78px;
								bottom: 73px;
							}

							&:nth-child(2) {
								bottom: 75px;
							}

							&:nth-child(3) {
								right: 48px;
								bottom: 73px;

								img {
									width: 29.5px;
									height: 31.2px;
								}
							}
							&.for-desk {
								display: flex;
							}
						}
					}
				}
			}
		}
	}

</style>
